import BrokerCreationTemplate from "./BrokerCreationTemplate";
import PersonSelect from "./PersonSelect";
import { Stack, Switch, Typography } from "@mui/material";
import Disabled from "components/common/Disabled";
import {
  useGetSortedBrokerList,
  useGetSortedBrokerListWithRefresh,
  WHOLESALE_BROKER_API_NAME,
} from "components/inputs/program/BrokerSupport";
import * as labels from "config.labels";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as peopleActions from "store/actions/people/peopleActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as peopleSelectors from "store/selectors/people/peopleSelectors";
import * as userSelectors from "store/selectors/user/userSelectors";

const WholesaleBrokerCreation = ({ onCreate, onClose }) => {
  const brokers = useGetSortedBrokerList(WHOLESALE_BROKER_API_NAME);

  const [createBroker] = staticDataService.useCreateWholesaleBrokerMutation();

  return (
    <BrokerCreationTemplate
      brokers={brokers}
      createBroker={createBroker}
      visibilityBaseTag={"<WholesaleBrokerCreation>"}
      defaultVisibilityOverrideById={{
        name: true,
        email: false,
        workNumber: false,
        mobileNumber: false,
        company: true,
        address: false,
        licenseNumber: true,
        location: false,
      }}
      formId={"wholesale-broker-creation-form"}
      title={"Add a new Wholesale broker"}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};

const WholesaleBroker = () => {
  const dispatch = useDispatch();
  const userConfig = useSelector(userSelectors.selectUserConfig);
  const switchVisible =
    userConfig.componentVisibility?.[
      "input.program.wholesaleBroker.switchable"
    ] ?? true;

  const broker = useSelector(peopleSelectors.selectWholesaleBroker);

  const [hasWholesaleBroker, setHasWholesaleBroker] = useState(
    !switchVisible || broker != null
  );
  useEffect(() => {
    if (!hasWholesaleBroker && (!switchVisible || broker != null)) {
      setHasWholesaleBroker(true);
    }
  }, [broker, hasWholesaleBroker, switchVisible]);

  const switchHasWholesaleBroker = (value) => {
    if (!value && broker != null) {
      dispatch(peopleActions.updateWholesaleBroker(null));
    }
    setHasWholesaleBroker(value);
  };
  const updateBroker = (value) => {
    dispatch(peopleActions.updateWholesaleBroker(value));
  };

  const [sortedBrokers, refreshBrokers] = useGetSortedBrokerListWithRefresh(
    WHOLESALE_BROKER_API_NAME
  );

  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  return (
    <Disabled ifReadOnly>
      {switchVisible && (
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography>
            {translateLabel(labels.WHOLESALE_BROKER_OPTION, {
              default: "Wholesale Broker?",
            })}
          </Typography>
          <Switch
            checked={hasWholesaleBroker}
            onChange={(e) => switchHasWholesaleBroker(e.target.checked)}
          />
        </Stack>
      )}
      {hasWholesaleBroker && (
        <PersonSelect
          person={broker}
          personList={sortedBrokers}
          onUpdatePerson={updateBroker}
          onUpdatePersonList={refreshBrokers}
          PersonCreationComponent={WholesaleBrokerCreation}
          label={translateLabel(labels.WHOLESALE_BROKER_TITLE, {
            default: "Wholesale Broker",
          })}
          showLabelOnCard
          showLicenseNumber
          searchProps={{
            showLicenseNumber: true,
          }}
        />
      )}
    </Disabled>
  );
};
export default WholesaleBroker;
